import React from 'react';

// Thánh Gia (Thánh Giuse - Đức Maria - Chúa Giêsu): 3 TRÁI TIM lồng nhau (đổi từ dáng người áo
// choàng tam giác sang trái tim, theo gợi ý icon "gia đình trái tim" phổ biến) nhưng GIỮ nguyên bản
// sắc Công giáo đã chọn từ trước: vẫn 3 nhân vật + vầng hào quang trên đầu mỗi người, chỉ đổi hình
// dáng THÂN. Đơn sắc (currentColor) - PHẢI giữ, không dùng 4 màu như icon tham khảo: icon này đặt ở
// rất nhiều nền màu khác nhau (text-white trên nền family-600/700, text-color-300 ở empty state...)
// và nhỏ nhất tới 14px (tab nav dưới) - 4 màu cố định sẽ vỡ hình ở size đó và không đổi theo context
// màu được, phá vỡ convention đơn sắc chung của cả components/Svgs.
//
// Mỗi thân là 1 path trái tim chuẩn (2 cung tròn tạo 2 thùy trên + 1 điểm nhọn dưới), thay cho
// path hình thang cũ. Giêsu vẽ SAU CÙNG (nằm trên, phía trước) - thân trái tim của Giêsu (rộng x=23
// đến 41) tràn vào đúng khoảng hở giữa 2 thân Giuse (hết ở x=29) và Maria (bắt đầu ở x=35), tạo hiệu
// ứng "con ở giữa, tựa vào 2 bên cha mẹ" giống ảnh tham khảo mà không cần chỉnh thêm gì.
export const HolyFamilySvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            {/* Thánh Giuse (trái) */}
            <circle cx="16" cy="15" r="8" fill="none" stroke="currentColor" strokeWidth="1.4" opacity="0.55"/>
            <circle cx="16" cy="15" r="6" fill="currentColor"/>
            <path fill="currentColor" d="M16,28.9 C16,21 3,21 3,33.6 C3,46.2 10.8,51.6 16,57 C21.2,51.6 29,46.2 29,33.6 C29,21 16,21 16,28.9 Z"/>

            {/* Đức Maria (phải) */}
            <circle cx="48" cy="15" r="8" fill="none" stroke="currentColor" strokeWidth="1.4" opacity="0.55"/>
            <circle cx="48" cy="15" r="6" fill="currentColor"/>
            <path fill="currentColor" d="M48,28.9 C48,21 35,21 35,33.6 C35,46.2 42.8,51.6 48,57 C53.2,51.6 61,46.2 61,33.6 C61,21 48,21 48,28.9 Z"/>

            {/* Chúa Giêsu Hài Đồng (giữa, phía trước, nhỏ hơn) */}
            <circle cx="32" cy="31" r="6" fill="none" stroke="currentColor" strokeWidth="1.4" opacity="0.7"/>
            <circle cx="32" cy="31" r="4.5" fill="currentColor"/>
            <path fill="currentColor" d="M32,41.6 C32,37 23,37 23,44.35 C23,51.7 28.4,54.85 32,58 C35.6,54.85 41,51.7 41,44.35 C41,37 32,37 32,41.6 Z"/>
        </svg>
    )
};
